import Vue from 'vue'
import VueRouter from 'vue-router'
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    // meta: { noCheck: true },
    component: () => import('../views/login/index.vue')
  },
  {
    path: '/my/index',
    name: 'My',
    component: () => import('../views/my/index.vue'),
    meta: { hasFooter: true, active: 'my', title: '个人信息' }
  },
  {
    path: '/my/info',
    name: 'myInfo',
    component: () => import('../views/my/info.vue'),
    meta: { title: '个人信息' }
  },
  {
    path: '/my/advice',
    name: 'advice',
    component: () => import('../views/my/advice.vue'),
    meta: { title: '系统建议' }
  },
  {
    path: '/my/about',
    name: 'about',
    component: () => import('../views/my/about.vue'),
    meta: { title: '关于我们' }
  },
  {
    path: '/my/record',
    name: 'record',
    component: () => import('../views/question/record.vue'),
    meta: { title: '答卷记录' }
  },
  {
    path: '/my/reward',
    name: 'reward',
    component: () => import('../views/my/reward.vue'),
    meta: { title: '奖励记录' }
  },
  {
    path: '/my/myShare',
    name: 'myShare',
    component: () => import('../views/my/share.vue'),
    meta: { title: '我的推广' }
  },
  {
    path: '/question/index',
    name: 'question',
    component: () => import('../views/question/index.vue'),
    meta: { hasFooter: true, active: 'question', title: '问卷列表' }
  },
  {
    path: '/question/detail',
    name: 'questionDetail',
    component: () => import('../views/question/detail.vue'),
    meta: { title: '问卷详情' }
  },
  {
    path: '/error',
    name: 'error',
    component: () => import('../views/error.vue'),
    meta: { title: '系统异常', noCheck: true }
  },
  {
    path: '/share',
    name: 'share',
    component: () => import('../views/Share.vue'),
    meta: { title: '我要推广' }
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: '/sudiao',
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

export default router
